import { moduleInit } from '../../core/base/moduleInit';
import { IPage, Page } from '../../core/configs/types';
import {
  CREATE_CRYPTO_LIB_MANAGER,
  READ_CRYPTO_LIB_MANAGER,
  READ_DOMAIN_SETTING,
  READ_PROFIT_WHITELIST,
  READ_SYSTEM_SETTING,
  READ_USER_LOG,
} from './scopes';
import DomainManager from '../pages/DomainManager';
import GlobalSettingManager from '../pages/GlobalSettingManager';
import React from 'react';
import CryptoLibCreatePage from '../pages/CryptoLibCreatePage';
import CryptoLibUpdatePage from '../pages/CryptoLibUpdatePage';
import ProfitWithdrawWhiteListPage from '../pages/ProfitWithdrawWhiteListPage';
import ApiLogPage from '../pages/ApiLogPage';
import OPDepositSourceList from '../pages/OPDepositSourceList';
import MchWalletTrxWhiteList from '../pages/MchWalletTrxWhiteList';
import OperationWalletManager from '../pages/OperationWalletManager';
import TrxSweepManager from '../pages/TrxSweepManager';
import CRotationSkipMatrix from '../pages/CRotationSkipMatrix';
import CollectCRotationSkipList from '../pages/CollectCRotationSkipList';
import WalletPoolManager from '../pages/WalletPoolManager';
import CReceiverManager from '../pages/CReceiverManager';

export const ModuleName = 'SystemSetting';
export const ModuleIdentity = 'SYSTEM-SETTING';

const _module = new moduleInit(ModuleName, ModuleIdentity);
export default _module;

export const MENU_SYMBOL_SYSTEM_SETTING = Symbol();

const pages: IPage[] = Page.createInstances([
  {
    id: 40341,
    uri: '',
    component: DomainManager,
    scopes: [READ_DOMAIN_SETTING],
    onClose: () => {},
  },
  {
    id: 40342,
    uri: '',
    component: () => <GlobalSettingManager title="全域設定管理" />,
    scopes: [READ_SYSTEM_SETTING],
    onClose: () => {},
  },
  {
    id: 40345,
    uri: '',
    component: () => <CryptoLibCreatePage />,
    scopes: [CREATE_CRYPTO_LIB_MANAGER],
    onClose: () => {},
  },
  {
    id: 40346,
    uri: '',
    component: () => <CryptoLibUpdatePage />,
    scopes: [READ_CRYPTO_LIB_MANAGER],
    onClose: () => {},
  },
  {
    id: 40347,
    uri: '',
    component: () => <ApiLogPage />,
    scopes: [READ_USER_LOG],
    onClose: () => {},
  },
  {
    id: 40343,
    uri: '',
    component: () => <ProfitWithdrawWhiteListPage />,
    scopes: [READ_PROFIT_WHITELIST],
    onClose: () => {},
  },
]);
const OPDepositSourcePage = Page.createInstance({
  id: 40348,
  uri: '',
  component: OPDepositSourceList,
  scopes: [READ_PROFIT_WHITELIST],
  onClose: () => null,
});
const MchWalletTrxWhiteListPage = Page.createInstance({
  id: 40349,
  uri: '',
  component: MchWalletTrxWhiteList,
  scopes: [READ_PROFIT_WHITELIST],
  onClose: () => null,
});

const OperationWalletPage = Page.createInstance({
  id: 40350,
  uri: '',
  component: () => <OperationWalletManager title="運營錢包管理" />,
  scopes: [READ_SYSTEM_SETTING],
  onClose: () => null,
});

const TrxSweepPage = Page.createInstance({
  id: 40351,
  uri: '',
  component: () => <TrxSweepManager title="一次性 TRX 回收" />,
  scopes: [READ_SYSTEM_SETTING],
  onClose: () => null,
});

const CRotationSkipPage = Page.createInstance({
  id: 40352,
  uri: '',
  component: () => <CRotationSkipMatrix title="出款 C 地址跳過" />,
  scopes: [READ_SYSTEM_SETTING],
  onClose: () => null,
});

const CollectCRotationSkipPage = Page.createInstance({
  id: 40353,
  uri: '',
  component: () => <CollectCRotationSkipList title="歸集 C 地址跳過" />,
  scopes: [READ_SYSTEM_SETTING],
  onClose: () => null,
});

const WalletPoolPage = Page.createInstance({
  id: 40354,
  uri: '',
  component: () => <WalletPoolManager title="預備錢包池" />,
  scopes: [READ_SYSTEM_SETTING],
  onClose: () => null,
});

const CReceiverPage = Page.createInstance({
  id: 40355,
  uri: '',
  component: () => <CReceiverManager title="C 收款地址名單" />,
  scopes: [READ_SYSTEM_SETTING],
  onClose: () => null,
});

_module.addPages([...pages, OPDepositSourcePage, MchWalletTrxWhiteListPage, OperationWalletPage, TrxSweepPage, CRotationSkipPage, CollectCRotationSkipPage, WalletPoolPage, CReceiverPage]);
_module.setMenu([
  {
    symbol: MENU_SYMBOL_SYSTEM_SETTING,
    label: '平台設置',
    menuId: 40,
    order: 30,
    iconId: 20,
    i18nLabel: { en_US: 'System Setting', zh_CN: '平台設置',vi_VN:'平台設置' },
    children: [
      {
        label: '域名管理',
        menuId: pages[0],
        i18nLabel: { en_US: 'Domain Management', zh_CN: '域名管理',vi_VN:'域名管理' },
      },
      {
        label: '全域設定管理',
        menuId: pages[1],
        i18nLabel: { en_US: 'Global Setting Management', zh_CN: '全域設定管理',vi_VN:'全域設定管理' },
      },
      {
        label: '利潤下發白名單',
        menuId: pages[5],
        i18nLabel: {
          en_US: 'Profit Withdraw Whitelist',
          zh_CN: '利潤下發白名單',vi_VN:'利潤下發白名單'
        },
      },
      {
        label: '維運充值來源',
        menuId: OPDepositSourcePage,
        i18nLabel: { en_US: 'OP Deposit Source', zh_CN: '維運充值來源',vi_VN:'維運充值來源' },
      },
      {
        label: '商戶錢包充TRX白名單',
        menuId: MchWalletTrxWhiteListPage,
        i18nLabel: { en_US: 'Mch Wallet TRX White List', zh_CN: '商戶錢包充TRX白名單',vi_VN:'商戶錢包充TRX白名單' },
      },
      {
        label: '運營錢包管理',
        menuId: OperationWalletPage,
        i18nLabel: { en_US: 'Operation Wallets', zh_CN: '運營錢包管理', vi_VN: '運營錢包管理' },
      },
      {
        label: '一次性 TRX 回收',
        menuId: TrxSweepPage,
        i18nLabel: { en_US: 'One-off TRX Sweep', zh_CN: '一次性 TRX 回收', vi_VN: '一次性 TRX 回收' },
      },
      {
        label: '出款 C 地址跳過',
        menuId: CRotationSkipPage,
        i18nLabel: { en_US: 'Payout C Skip', zh_CN: '出款C地址跳過', vi_VN: '出款C地址跳過' },
      },
      {
        label: '歸集 C 地址跳過',
        menuId: CollectCRotationSkipPage,
        i18nLabel: { en_US: 'Collect C Skip', zh_CN: '歸集C地址跳過', vi_VN: '歸集C地址跳過' },
      },
      {
        label: '預備錢包池',
        menuId: WalletPoolPage,
        i18nLabel: { en_US: 'Wallet Pool', zh_CN: '預備錢包池', vi_VN: '預備錢包池' },
      },
      {
        label: 'C 收款地址名單',
        menuId: CReceiverPage,
        i18nLabel: { en_US: 'C Receiver List', zh_CN: 'C收款地址名單', vi_VN: 'C收款地址名單' },
      },
      {
        label: '產生加密套件',
        menuId: pages[2],
        i18nLabel: { en_US: 'Create Crypto Lib', zh_CN: '產生加密套件',vi_VN:'產生加密套件' },
      },
      {
        label: '更換加密套件',
        menuId: pages[3],
        i18nLabel: { en_US: 'Update Crypto Lib', zh_CN: '更換加密套件',vi_VN:'Cập nhật bộ tiền mã hóa' },
      },
      {
        label: '操作紀錄查詢',
        menuId: pages[4],
        i18nLabel: { en_US: 'Api Log', zh_CN: '操作紀錄查詢',vi_VN:'操作紀錄查詢' },
      },
    ],
  },
]);
